import React, { useEffect, useState } from "react";
//import "./productstable.css";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Button from "@mui/material/Button";

import { useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import AddCircleOutlineTwoToneIcon from '@mui/icons-material/AddCircleOutlineTwoTone';

import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, MenuItem, TextField } from "@mui/material";
import { DataGrid, GridApi, GridColDef, GridValueGetterParams, GridCellParams, GridDeleteForeverIcon, GridDeleteIcon } from '@mui/x-data-grid';
import { CustomerService } from "../../../service/customers.service";
import { alpha, styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import ManageAccountsTwoToneIcon from '@mui/icons-material/ManageAccountsTwoTone';
import RetailAccountDetails from "../retail/RetailAccountDetails";


const EnterpriseUserDialog = (props:any) => {

    const customerService = new CustomerService();

    const [brandsData, setbrandsData] = useState<any[]>([]);

    const [salesRepUserId, setSalesRepUserId] = useState<any>("");

    const [salesRepUserStatus, setSalesRepUserStatus] = useState<any>("N");

    const [openSalesConfirmDlg, setOpenSalesConfirmDlg] = useState<any>(false);

    // Add User (attach an existing app user to this enterprise) + the two status-102 confirms.
    // The backend replies 102 instead of acting when the move would take a user out of another
    // enterprise, or when a remove would strip this enterprise's last user; both are re-sent
    // with force=1 once the admin confirms.
    const [openAddUser, setOpenAddUser] = useState(false);
    const [addMobile, setAddMobile] = useState("");
    const [addRole, setAddRole] = useState("A");
    const [addErr, setAddErr] = useState("");
    const [adding, setAdding] = useState(false);
    const [confirmMove, setConfirmMove] = useState<any>(null);    // {msg}
    const [confirmRemove, setConfirmRemove] = useState<any>(null); // {userid, msg}



    //const [availableStatus, setAvailableStatus] = useState<OrderStatus[]>([]);

    const navigate = useNavigate();

    const removeUser = (bIndex: string, action: string) => {

        var userid =   (brandsData[Number(bIndex) - 1]).userid

        doRemoveUser(userid, 0);
    };

    // force=0 first; a 102 means "this is the enterprise's last user" and opens a confirm that
    // re-sends with force=1. Note props.callback() closes this dialog, so it must NOT run on 102.
    const doRemoveUser = (userid: any, force: number) => {

        customerService.removeUserFromEnt(userid, force).then((res: any) => {

            if (res != null) {
              if (res.status == 102) {
                setConfirmRemove({ userid: userid, msg: res.msg });
                return;
              }
              if (res.status == 100) {
                toast.success("User removed Successfully !!!", {
                  position: toast.POSITION.BOTTOM_CENTER,
                  autoClose: 2000,
                  hideProgressBar: true,
                });

              } else {
                toast.error(res.msg ? res.msg : "Action Failed !!!", {
                  position: toast.POSITION.BOTTOM_CENTER,
                  autoClose: 3000,
                  hideProgressBar: true,
                });

              }

              props.callback();
            }

          }).catch((err: any) => {
            console.log('err ', err);

          });


    };

    // Attach an existing app user by mobile. force=0 first; 102 = the user already belongs to a
    // different enterprise, so confirm before moving them.
    const submitAddUser = (force: number) => {

        const mob = addMobile.trim();
        if (mob.length != 10) {
            setAddErr("Enter the user's 10-digit mobile number");
            return;
        }
        setAddErr("");
        setAdding(true);

        customerService.linkUserToEnterprise(mob, props.entDetails.entID, addRole, force).then((res: any) => {

            setAdding(false);
            if (res == null) {
                setAddErr("No response from server");
                return;
            }
            if (res.status == 102) {
                setConfirmMove({ msg: res.msg });
                return;
            }
            if (res.status == 100) {
                toast.success(res.msg ? res.msg : "User added successfully.", {
                  position: toast.POSITION.BOTTOM_CENTER,
                  autoClose: 2000,
                  hideProgressBar: true,
                });
                setOpenAddUser(false);
                setAddMobile("");
                setAddRole("A");
                props.callback();
            } else {
                // keep the dialog open and show the real reason (unknown mobile, bad format, ...)
                setAddErr(res.msg ? res.msg : "Could not add the user");
            }

          }).catch((err: any) => {
            console.log('err ', err);
            setAdding(false);
            setAddErr("Could not add the user");
          });
    };

    const [open, setOpen] = React.useState(false);

    // edit a single enterprise user (name / mobile / status) in the shared user dialog
    const [editUser, setEditUser] = useState<any>(null);
    const [openEdit, setOpenEdit] = useState(false);

    const openEditUser = (bIndex: string) => {
        const row = brandsData[Number(bIndex) - 1];
        setEditUser({ ...row, userId: row.userid });
        setOpenEdit(true);
    };

    const handleEditCallBack = () => {
        setOpenEdit(false);
        props.callback();
    };



    const columns: GridColDef[] = [
        { field: 'id', headerName: 'ID', flex: 1, width: 300 },
       
        { field: 'username', headerName: 'User Name', flex: 1 },
        { field: 'mobileno', headerName: 'Mobile no', flex: 1 },
        {
            field: 'status', headerName: 'Status', flex: 1,

            renderCell: (params) => {
                return <div>
                    {params.value == -1 && (<p style={{ color: "blue" }}>Unknown</p>)
                        || params.value == 0 && (<p style={{ color: "red" }}>Deactive</p>)
                        || params.value == 1 && (<p style={{ color: "green" }}>Active</p>)
                    }

                </div>

            }

        },

        {
            field: 'salesRep', headerName: 'Sales Rep', flex: 1,

            renderCell: (params) => {
                return  <div className="col-md-6"><input  type="checkbox" name="field_salesRep" id="" className='mr-2'
                onChange={(e) => showSalesRepConfirmDlg( e ,params.id )} checked={params.value == "Y"}  /></div>

            }

        },
      

        {

            field: "action",
            headerName: "Action",
            sortable: false,
            renderCell: (params) => {
                const onClick = (e: { stopPropagation: () => void; }) => {
                    e.stopPropagation(); // don't select this row after clicking

                    const api: GridApi = params.api;
                    const thisRow: Record<string, GridCellParams> = {};

                    api
                        .getAllColumns()
                        .filter((c: { field: string; }) => c.field !== "__check__" && !!c)
                        .forEach(
                            (c: { field: string | number; }) => (thisRow[c.field] = params.value.getValue(params.id, c.field))
                        );
                };

                return <div>
                    <Button title="Edit user (mobile / status)" onClick={(e) => openEditUser(params.value)} > <IconButton> <ManageAccountsTwoToneIcon fontSize="small" /></IconButton></Button>
                    <Button title="Remove from enterprise" onClick={(e) => removeUser(params.value, "edit")} > <IconButton> <GridDeleteIcon fontSize="small" /></IconButton></Button>

                </div>
            },
            flex: 1
        }

    ];
    //useEffect(() => {
    const submitRequest = (checkApprovalStatus: number) => {

    }//, [selectedEnterprise, selectedStatus]);

    function showSalesRepConfirmDlg(event:any , index:any ) {
        let checked = (event.target as HTMLInputElement).checked;
        console.log("event : "+ checked)
        console.log("indd "+  index)
        var userid =   (brandsData[Number(index) - 1]).userid

        console.log("userid  "+  userid)
        setSalesRepUserId(userid)
        setSalesRepUserStatus(checked?"Y":"N")
        
        setOpenSalesConfirmDlg(true)
    }


    const loadbrandsData = (userarray:any[]) => {

     
            const res = userarray;
            let cnt1 = 0;
            const peopleWithImages = res.map((person: any, index: any) => {
                console.log("iterate : ",person)
                cnt1 = cnt1 + 1;
                return {
                    ...person,                    
                    id: cnt1,
                    action: cnt1 //person.brandId,
                };

            });
            setbrandsData(peopleWithImages)

    }

    let isLoadDataInit = false;
    useEffect(() => {

        if (!isLoadDataInit) {
            isLoadDataInit = true;

            //console.log("selecttt : "+props.entDetails.userlist[0].mobileno)

            console.log("selecttt : "+props.entDetails.userlist)

            loadbrandsData(props.entDetails.userlist);
        }

    }, [])

    interface DialogTitleProps {
        id: string;
        children?: React.ReactNode;
        onClose: () => void;
    }

    function BootstrapDialogTitle(props: DialogTitleProps) {
        const { children, onClose, ...other } = props;

        return (
            <DialogTitle sx={{ m: 0, p: 2 ,minWidth:300 }} {...other}>
                {children}
                {onClose ? (
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                ) : null}
            </DialogTitle>
        );
    }


    const BootstrapDialog = styled(Dialog)(({ theme }) => ({
        '& .MuiDialogContent-root': {
            padding: theme.spacing(2),            
        },
        '& .MuiDialogActions-root': {
            padding: theme.spacing(1),
        },
    }));

    function handleSalesRepDlgClose(){
        setOpenSalesConfirmDlg(false)
    }


    function handleSalesRepConfirm(){
        setOpenSalesConfirmDlg(false)
        // do api call here 

        customerService.setSalesRep(salesRepUserId , salesRepUserStatus).then((res: any) => {

            if (res != null) {
              if (res.status == 100) {
                toast.success("Sales Rep updated Successfully !!!", {
                  position: toast.POSITION.BOTTOM_CENTER,
                  autoClose: 2000,
                  hideProgressBar: true,
                });
      
              } else {
                let msg = "Action Failed !!!" 
                if (res.status){
                    msg = res.status + ""
                }
                toast.error(msg, {
                  position: toast.POSITION.BOTTOM_CENTER,
                  autoClose: 2000,
                  hideProgressBar: true,
                });
      
              }
      
              props.callback();
            }
      
          }).catch((err: any) => {
            console.log('err ', err);
            
          });


    }

    return (
        <div className="App border card">
            <div className="col-md-12  row">
                <div className="col-12" style={{ display: 'flex', justifyContent: 'flex-end', padding: '8px' }}>
                    <Button variant="outlined" size="small" startIcon={<AddCircleOutlineTwoToneIcon />}
                        onClick={() => { setAddMobile(""); setAddRole("A"); setAddErr(""); setOpenAddUser(true); }}>
                        Add User
                    </Button>
                </div>

            </div>
            {
                <div style={{ width: '100%' }}>
                    <DataGrid
                        // table customization start
                        sx={{
                            '& .MuiDataGrid-columnHeaderTitle': {
                                whiteSpace: "break-spaces", lineHeight: 1, fontSize: "13px", fontWeight: "bold",
                            },
                            '& .MuiDataGrid-columnHeader': {
                                backgroundColor: "#D0D0D0"
                            },
                            '& .Mui-odd': {
                                textOverflow: "inherit", fontSize: "12px", textAlign: "left"
                            },

                            '& .Mui-even': {
                                backgroundColor: "#F7f7f7", textOverflow: "inherit", fontSize: "12px", textAlign: "left"

                            },

                            '& .Mui-cellown': {
                                paddingTop: 0, paddingBottom: 0

                            },


                            '& .MuiTablePagination-displayedRows': {
                                'margin-top': '1em',
                                'margin-bottom': '1em'
                              },
                              '& .MuiTablePagination-displayedRows, .MuiTablePagination-selectLabel': {
                                'margin-top': '1em',
                                'margin-bottom': '1em'
                              }

                     

                        }}

                        getCellClassName={(params) => 'Mui-cellown'}
                        getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'}
                        autoHeight={true}
                        getRowHeight={() => 'auto'}

                        // table customization


                        rows={brandsData}
                        columns={columns}
                        initialState={{
                            pagination: {
                                paginationModel: { page: 0, pageSize: 10 },
                            },
                        }}
                        pageSizeOptions={[10, 25, 50]}

                    />
                </div>
            }

       
            <BootstrapDialog

                //fullWidth
                //  maxWidth={"sm"}
                // style={{width:'100%'}}             
                onClose={handleSalesRepDlgClose}
                aria-labelledby="customized-dialog-title"
                open={openSalesConfirmDlg}>

                <BootstrapDialogTitle
                    id="customized-dialog-title center" onClose={handleSalesRepDlgClose}>
                    Are you sure ?
                </BootstrapDialogTitle>



                <DialogActions>

                    <Button onClick={handleSalesRepDlgClose}>Cancel</Button>
                    <Button onClick={handleSalesRepConfirm}>Ok</Button>

                </DialogActions>
            </BootstrapDialog>

            <BootstrapDialog
                fullWidth
                onClose={() => setOpenEdit(false)}
                aria-labelledby="customized-dialog-title"
                open={openEdit}>

                <BootstrapDialogTitle id="customized-dialog-title" onClose={() => setOpenEdit(false)}>
                    Enterprise User Details
                </BootstrapDialogTitle>

                {editUser && <RetailAccountDetails retailUser={editUser} callback={handleEditCallBack} ></RetailAccountDetails>}

                <DialogActions>
                </DialogActions>
            </BootstrapDialog>

            {/* Add User - attach an existing app user to this enterprise by mobile number.
                The user must already exist and be Active (create them under Customers -> Retail
                first); this only links them, it never creates an account. */}
            <BootstrapDialog
                fullWidth
                maxWidth="xs"
                onClose={() => setOpenAddUser(false)}
                aria-labelledby="add-user-dialog-title"
                open={openAddUser}>

                <BootstrapDialogTitle id="add-user-dialog-title" onClose={() => setOpenAddUser(false)}>
                    Add User to Enterprise
                </BootstrapDialogTitle>

                <DialogContent>
                    <TextField
                        autoFocus
                        fullWidth
                        size="small"
                        margin="dense"
                        label="Registered Mobile Number"
                        value={addMobile}
                        error={addErr != ""}
                        helperText={addErr != "" ? addErr : "The user must already be registered and Active in the app"}
                        inputProps={{ inputMode: 'numeric', maxLength: 10 }}
                        onChange={(e) => { setAddMobile(e.target.value.replace(/[^0-9]/g, '')); setAddErr(""); }}
                    />
                    <TextField
                        select
                        fullWidth
                        size="small"
                        margin="dense"
                        label="Role"
                        value={addRole}
                        onChange={(e) => setAddRole(e.target.value)}
                    >
                        <MenuItem value="A">Admin</MenuItem>
                        <MenuItem value="E">Employee</MenuItem>
                    </TextField>
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setOpenAddUser(false)}>Cancel</Button>
                    <Button disabled={adding} onClick={() => submitAddUser(0)}>{adding ? "Adding..." : "Add"}</Button>
                </DialogActions>
            </BootstrapDialog>

            {/* 102 - the mobile belongs to a user of a DIFFERENT enterprise */}
            <BootstrapDialog
                onClose={() => setConfirmMove(null)}
                aria-labelledby="confirm-move-title"
                open={confirmMove != null}>

                <BootstrapDialogTitle id="confirm-move-title" onClose={() => setConfirmMove(null)}>
                    Move this user ?
                </BootstrapDialogTitle>

                <p style={{ fontSize: 15, marginLeft: 20, marginRight: 20, maxWidth: 420 }}>
                    {confirmMove && confirmMove.msg}
                </p>

                <DialogActions>
                    <Button onClick={() => setConfirmMove(null)}>Cancel</Button>
                    <Button onClick={() => { setConfirmMove(null); submitAddUser(1); }}>Move</Button>
                </DialogActions>
            </BootstrapDialog>

            {/* 102 - removing this user would leave the enterprise with no users at all */}
            <BootstrapDialog
                onClose={() => setConfirmRemove(null)}
                aria-labelledby="confirm-remove-title"
                open={confirmRemove != null}>

                <BootstrapDialogTitle id="confirm-remove-title" onClose={() => setConfirmRemove(null)}>
                    Remove the last user ?
                </BootstrapDialogTitle>

                <p style={{ fontSize: 15, marginLeft: 20, marginRight: 20, maxWidth: 420 }}>
                    {confirmRemove && confirmRemove.msg}
                </p>

                <DialogActions>
                    <Button onClick={() => setConfirmRemove(null)}>Cancel</Button>
                    <Button style={{ color: "red" }} onClick={() => {
                        const uid = confirmRemove.userid;
                        setConfirmRemove(null);
                        doRemoveUser(uid, 1);
                    }}>Remove</Button>
                </DialogActions>
            </BootstrapDialog>

        </div>

    );
}


export default EnterpriseUserDialog;
